import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getClubBookingByID } from "state/school_money/selectors";

export default function* goToClubBookingSaga(action) {
  
  const { clubBookingID } = action.payload;
  
  const clubBooking = yield select(getClubBookingByID, clubBookingID);
  const studentID = clubBooking.get("studentID");
  
  history.push(`/school_money/clubs/${studentID}/`);
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/goToClubBookingSaga.js